import _createPlugin2 from "../util/createPlugin";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: () => _default
});
const _createPlugin = /*#__PURE__*/_interopRequireDefault(_createPlugin2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const _default = _createPlugin.default;
export default exports;